<template>
  <div>
    <div class="face_header">
      <div class="face_header_con">
        <p class="face_header_lf">{{ this.testInfo.examName }}</p>
        <a class="face_header_rg" @click="logoutHandle">
          <span class="headsp"><img src="@/assets/images/exit.png"/></span>
          退出
        </a>
        <router-link to="/profile" class="face_header_rg">
          <span class="headsp"><img src="../assets/images/icon-user.png"/></span
          >{{ this.userInfo.userName }}
        </router-link>
      </div>
    </div>
    <!-- <div class="query_tit">
      <ul>
        <a href="javascript:void(0);" @click="readNotice()">1、阅读考试须知</a
        >&nbsp;&nbsp;&nbsp;&nbsp;
        <a href="javascript:void(0);" @click="confirmInfo()">2、确认个人信息</a>
      </ul>
    </div> -->
    <div class="query_con">
      <h2 class="exam_con_t xz_t">阅读考试须知</h2>
      <p class="ksxz_ft">
        {{ this.testInfo.examName }}<br />
        答题时间：{{ this.testInfo.answerLength }}分钟
        <el-input
          type="textarea"
          v-model="testInfo.remark"
          :readonly="true"
          :autosize="true"
          class="textClass"
        />

      <!-- <span class="ksxz_con" @click="closep()" style="cursor: pointer;"
          >我已认真阅读了考试须知</span
        > -->
      </p>
      <a href="javascript:void(0);" @click="nextStep()" class="query_btn"
        >确认，下一步</a
      >
    </div>
  </div>
</template>

<script>
import { getExamById, createH5FaceOrder, logout, myInfo } from "@/api/login";
export default {
  name: "ExamNeedToKnow",
  data() {
    return {
      examBean: {
        token: ""
      },
      tokenBean: {
        token: "",
        examUserId: ""
      },
      testInfo: {},
      userInfo: {},
      examUserId: "",
      uploadUrl: process.env.VUE_APP_RETURN_URL,
      readExamNotice: true,
      allowResume: ""
    };
  },
  created() {
    this.examBean.token = this.getToken();
    this.examUserId = this.$route.query.examUserId;
    this.tokenBean.token = this.getToken();
    this.tokenBean.examUserId = this.examUserId;
    this.initData();
  },
  computed: {
    token() {
      return this.getToken();
    }
  },
  methods: {
    initData() {
      console.log(this.tokenBean);
      getExamById(this.tokenBean).then(res => {
        console.log(res);
        if (res.code === 200) {
          this.testInfo = res.data;
          console.log(this.testInfo);
          this.allowResume = this.testInfo.allowResume;
        } else if (res.code === 8003) {
          this.$router.push("/login");
          return;
        }
      });
      myInfo(this.tokenBean).then(res => {
        if (res.code === 200) {
          console.log(res.data);
          this.userInfo = res.data.user;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    closep() {
      this.readExamNotice = false;
    },
    // nextStep() {
    //   this.$router.push({
    //     path: "/confirmProfile",
    //     query: { examUserId: this.examBean.examUserId }
    //   });
    // },
    nextStep() {
      //判度是否允许浏览器考试
      if (this.testInfo.allowWeb === 0) {
        this.$message.error(
          "该考试不允许考生使用电脑浏览器参加考试，请用手机APP参加考试"
        );
        return;
      }

      if (this.testInfo.state === 2 && this.testInfo.allowResume === 2) {
        this.$message.error(
          "该考试异常退出，需要老师在后台检查重置后才允许恢复考试，请认真阅读考试须知"
        );
        return;
      }


      // 需要前置摄像头实时监控
      /*
      if (this.testInfo.frontCamera === 2) {
        this.$router.push({
          path: "/frontCameraPush",
          query: { examUserId: this.examUserId }
        });
        return;
      }
      */

      // 启用人脸识别(腾讯人脸核身)
      if (this.testInfo.loginDetect === 2) {
        if (this.userInfo.faceStatus != 3) {
          alert("考生还没有头像相片，先进行头像相片采集");
          this.$router.push("/profile");
          return;
        }
        createH5FaceOrder(this.tokenBean).then(res => {
          console.log(res.data);
          const callBackUrl = encodeURIComponent(
            this.uploadUrl + this.examUserId
          );
          this.redirectUrl =
            "https://ida.webank.com/api/pc/login?webankAppId=" +
            res.data.config.wbappid +
            "&version=" +
            res.data.config.version +
            "&nonce=" +
            res.data.config.nonce +
            "&orderNo=" +
            res.data.result.data.orderNo +
            "&h5faceId=" +
            res.data.result.data.faceId +
            "&url=" +
            callBackUrl +
            "&userId=" +
            res.data.result.data.userId +
            "&sign=" +
            res.data.result.data.sign;
            console.log(this.redirectUrl);
            window.location.href = this.redirectUrl;
        });
        return;
      }

      // 需要过程抓拍，且开启检测摄像头
      if (this.testInfo.detectInprocess ===2 &&  this.testInfo.useVideo === 2) {
          this.$router.push({
          path: "/checkVideo",
          query: { examUserId: this.examUserId }
        });
        return;
      }

      // 需要后置摄像头（手机摄像头）实时监控
      if (this.testInfo.backCamera === 2) {
        this.$router.push({
          path: "/backCameraQrcode",
          query: { examUserId: this.examUserId }
        });
        return;
      }

      //进入确认
      this.$router.push({
        path: "/examConfirm",
        query: { examUserId: this.examUserId }
      });
      
    },
    readNotice() {
      this.$router.push({
        path: "/examNeedToKnow",
        query: { examUserId: this.examBean.examUserId }
      });
    },
    confirmInfo() {
      this.$router.push({
        path: "/confirmProfile",
        query: { examUserId: this.examBean.examUserId }
      });
    },
    logoutHandle() {
      if (confirm("退出确认")) {
        this.tokenBean.token = this.token;
        logout(this.tokenBean).then(res => {
          if (res.code === 200) {
            this.removeUserInfo();
            this.$router.push("/login");
          }
        });
      }
    }
  }
};
</script>

<style scoped></style>
